import { render, staticRenderFns } from "./search-product-location.vue?vue&type=template&id=2fb71e1a&"
import script from "./search-product-location.vue?vue&type=script&lang=ts&"
export * from "./search-product-location.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports